module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm1"
  }, [_vm._v("Who durst be so bold with a few crooked boards nailed together, a stick standing upright, and a rag tied to it, to adventure into the ocean?")]), _vm._v(" "), _c('p', {
    staticClass: "fm2"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THOMAS FULLER")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_vm._v("Bravery never goes out of fashion.")]), _vm._v(" "), _c('p', {
    staticClass: "fm2"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("WILLIAM MAKEPEACE THACKERAY")])]), _vm._v(" "), _c('p', {
    staticClass: "fm"
  }, [_vm._v("We reached Dunkirk at 3am, where we put up. A very bloody sight.")]), _vm._v(" "), _c('p', {
    staticClass: "fm2"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("SUB-LIEUTENANT EDWARD BERTHON, RN, A SURVIVOR")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e96bae3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Fm1.vue
// module id = 72
// module chunks = 0